// Public catalogue content synchronized from https://hf.mltcloud.com/ on 2026-09-18.
export const resources = [
  {
    "slug": "qq-music",
    "title": "腾讯音乐・热歌版曲库",
    "category": "音乐",
    "summary": "提供 100 万首、6000 万首两套 IOT 定制正版曲库，无需登录 QQ 音乐账号，音乐内容主要涵盖当下流行歌单，适配智能音箱、智能手表、口袋学习机、AI 陪伴玩具等，适合全年龄段",
    "description": "提供 100 万首、6000 万首两套 IOT 定制正版曲库，无需登录 QQ 音乐账号，音乐内容主要涵盖当下流行歌单，适配智能音箱、智能手表、口袋学习机、AI 陪伴玩具、各类具备音频播放能力的 IoT 硬件，适合全年龄段\n免账号畅听，按月 / 终身两种授权灵活合作",
    "logoText": "QQ",
    "logoTone": "yellow",
    "image": "qq-music.webp",
    "scenarios": [
      "适配智能音箱、智能手表、口袋学习机、AI 陪伴玩具、各类具备音频播放能力的 IoT 硬件，适合全年龄段"
    ],
    "sortOrder": 1
  },
  {
    "slug": "tme-ertong",
    "title": "腾讯音乐・儿童专属曲库",
    "category": "音乐",
    "summary": "约10万首歌曲，涵盖哄睡摇篮曲、中英文儿歌、国学童谣、儿童故事、科普教育等多类目。适配儿童手表、智能音箱、儿童机器人机器狗、电子吧唧等，适合 0‑12 岁（婴幼儿至小学阶段）",
    "description": "腾讯音乐（TME）的儿童+热歌合作曲库约10万首歌曲，涵盖纯音乐、哄睡摇篮曲、中英文儿歌、国学童谣、流行热歌、轻音乐、儿童故事、科普教育等多类目，由4100余位歌手演绎。适配儿童手表、听力宝、故事机、智能音箱、口袋学习机、儿童机器人机器狗、电子吧唧、AI 陪伴玩具等，适合 0‑12 岁（婴幼儿至小学阶段）\n海量正版儿童音频，陪伴孩子启蒙与睡前时光",
    "logoText": "儿童专属曲库",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "适配儿童手表、听力宝、故事机、智能音箱、口袋学习机、儿童机器人机器狗、电子吧唧、AI 陪伴玩具等，适合 0‑12 岁（婴幼儿至小学阶段）"
    ],
    "sortOrder": 2
  },
  {
    "slug": "tme-xiqu",
    "title": "腾讯音乐・国风戏曲热歌曲库",
    "category": "音乐",
    "summary": "共 1000 首国风戏曲改编金曲，660余位歌手演绎，主打国风流行、古风音乐、戏曲改编类热门歌曲。适配智能音箱、智能闹钟、智能手表、AI 陪伴玩具等具备音频播放能力的硬件，适合全年龄段",
    "description": "腾讯音乐国风戏曲专项曲库，共 1000 首国风戏曲改编金曲，660余位歌手演绎，主打国风流行、古风音乐、戏曲改编类热门歌曲，用于文化熏陶、休闲收听。适配智能音箱、智能闹钟、智能手表、AI 陪伴玩具等具备音频播放能力的硬件，适合全年龄段\n老少皆宜，休闲聆听浸润传统国风文化",
    "logoText": "国风戏曲",
    "logoTone": "pink",
    "image": null,
    "scenarios": [
      "适配智能音箱、智能闹钟、智能手表、AI 陪伴玩具等具备音频播放能力的硬件，适合全年龄段"
    ],
    "sortOrder": 3
  },
  {
    "slug": "baomihua",
    "title": "爆米花・戏曲广场舞视频资源",
    "category": "音乐",
    "summary": "囊括越剧、黄梅戏等众多地方剧种正本、经典选段以及广场舞教学演示视频，内容贴合长辈休闲文娱需求，适配带屏智能音箱、带屏智能闹钟、AI陪伴玩具、看戏机，适合全年龄段，侧重中老年文娱使用",
    "description": "面向中老年群体的垂直视频资源库，囊括越剧、黄梅戏等众多地方剧种正本、经典选段以及广场舞教学演示视频，内容贴合长辈休闲文娱需求，适配带屏智能音箱、带屏智能闹钟、家用带屏IoT设备、AI陪伴玩具、看戏机，适合全年龄段，侧重中老年文娱使用\n传承传统曲艺，丰富中老年居家文娱生活",
    "logoText": "爆米花",
    "logoTone": "orange",
    "image": null,
    "scenarios": [
      "适配带屏智能音箱、带屏智能闹钟、家用带屏IoT设备、AI陪伴玩具、看戏机，适合全年龄段，侧重中老年文娱使用"
    ],
    "sortOrder": 4
  },
  {
    "slug": "netease-cloud-music",
    "title": "网易云音乐・全曲库",
    "category": "音乐",
    "summary": "8000 万免费音源，含资讯故事与少儿读物，支持用户自主升级会员。适配智能音箱、智能闹钟、学习平板、AI陪伴玩具等具备音频播放能力的IoT硬件，适合全年龄段",
    "description": "网易云音乐正版音乐资源，拥有 8000 万免费音源，涵盖华语流行、独立音乐人作品、摇滚民谣、欧美日韩、ACG、影视原声、怀旧老歌等多元曲风，支持用户自主升级会员。适配智能音箱、智能闹钟、学习平板、AI陪伴玩具等具备音频播放能力的IoT硬件，适合全年龄段\n全年龄段碎片聆听，丰富音频内容随心畅听",
    "logoText": "网易",
    "logoTone": "red",
    "image": "netease-cloud-music.webp",
    "scenarios": [
      "适配智能音箱、智能闹钟、学习平板、AI陪伴玩具等具备音频播放能力的IoT硬件，适合全年龄段"
    ],
    "sortOrder": 5
  },
  {
    "slug": "migu-music",
    "title": "咪咕音乐・全品类曲库",
    "category": "音乐",
    "summary": "覆盖华语流行、港台金曲、欧美日韩、国风、ACG、影视综艺原声、经典老歌等多元曲风，内容持续更新，适配智能音箱、智能闹钟、学习平板、AI 陪伴玩具等，适合全年龄段",
    "description": "咪咕音乐正版全品类音乐资源，曲库覆盖华语流行、港台金曲、欧美日韩、国风、ACG、影视综艺原声、经典老歌等多元曲风，内容持续更新，适配智能音箱、智能闹钟、学习平板、AI 陪伴玩具等具备音频播放能力的 IoT 硬件，适合全年龄段\n成人休闲听歌、幼儿早教哄睡一站式音频资源",
    "logoText": "MG",
    "logoTone": "pink",
    "image": "migu-music.webp",
    "scenarios": [
      "适配智能音箱、智能闹钟、学习平板、AI 陪伴玩具等具备音频播放能力的 IoT 硬件，适合全年龄段"
    ],
    "sortOrder": 6
  },
  {
    "slug": "spotify",
    "title": "Spotify‑Connect・音乐投播能力",
    "category": "音乐",
    "summary": "Spotify 官方 WiFi 投播协议，音频由云端直推硬件，手机仅做遥控器，多房间播放，需终端用户 Spotify Premium 会员。适配出海 WiFi 智能音箱、带屏海外 IoT 音频硬件，适合全年龄段",
    "description": "Spotify 官方 WiFi 投播协议，音频由云端直推硬件，手机仅做遥控器，多房间播放，需终端用户 Spotify Premium 会员，硬件不存储曲库。适配出海 WiFi 智能音箱、带屏海外 IoT 音频硬件，适合全年龄段",
    "logoText": "Spotify",
    "logoTone": "ink",
    "image": null,
    "scenarios": [
      "适配出海 WiFi 智能音箱、带屏海外 IoT 音频硬件，适合全年龄段"
    ],
    "sortOrder": 7
  },
  {
    "slug": "feed",
    "title": "feed.fm・海外场景歌单服务",
    "category": "音乐",
    "summary": "海外 B2B 商用音乐 SDK 服务，版权全包；预制场景电台歌单，支持定制印尼本地曲库，以非交互式电台播放为主。适配面向东南亚出海智能音箱、IoT 音频硬件，适合全年龄段",
    "description": "海外 B2B 商用音乐 SDK 服务，版权全包；预制场景电台歌单，支持定制印尼本地曲库，以非交互式电台播放为主。适配面向东南亚出海智能音箱、IoT 音频硬件，适合全年龄段",
    "logoText": "feed.fm",
    "logoTone": "yellow",
    "image": null,
    "scenarios": [
      "适配面向东南亚出海智能音箱、IoT 音频硬件，适合全年龄段"
    ],
    "sortOrder": 8
  },
  {
    "slug": "shuimianliaoyu",
    "title": "睡眠冥想疗愈・音乐",
    "category": "音乐",
    "summary": "100类助眠疗愈类音频，包含自然白噪音、舒缓轻音乐、冥想引导音频，用于舒缓情绪、减压放松、辅助入睡，适配智能闹钟、智能音箱、睡眠仪、AI陪伴玩具，适合全年龄段",
    "description": "100类助眠疗愈类音频资源，包含自然白噪音、舒缓轻音乐、冥想引导音频，用于舒缓情绪、减压放松、辅助入睡，适配智能闹钟、智能音箱、睡眠仪、AI陪伴玩具、穿戴音频硬件，适合全年龄段\n静心舒缓减压，营造静谧沉浸式听觉氛围",
    "logoText": "睡眠冥想疗愈",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "适配智能闹钟、智能音箱、睡眠仪、AI陪伴玩具、穿戴音频硬件，适合全年龄段"
    ],
    "sortOrder": 9
  },
  {
    "slug": "shuimianmingxiang",
    "title": "睡眠冥想疗愈・视频",
    "category": "音乐",
    "summary": "100类助眠疗愈类视频，包含自然风景慢镜头、呼吸冥想引导视频、沉浸式夜景光影画面，配合舒缓配乐，用于睡前放松、情绪减压、正念冥想练习，适配带屏智能闹钟、学习平板，适合全年龄段",
    "description": "100类助眠疗愈类视频资源库，包含自然风景慢镜头、呼吸冥想引导视频、沉浸式夜景光影画面，配合舒缓配乐，用于睡前放松、情绪减压、正念冥想练习，适配带屏智能闹钟、学习平板、家用带屏 IoT 设备、AI 陪伴玩具，适合全年龄段\n视听双重舒缓，自习、休憩、哄睡多元场景适用",
    "logoText": "睡眠冥想疗愈",
    "logoTone": "pink",
    "image": null,
    "scenarios": [
      "适配带屏智能闹钟、学习平板、家用带屏 IoT 设备、AI 陪伴玩具，适合全年龄段"
    ],
    "sortOrder": 10
  },
  {
    "slug": "ximalaya",
    "title": "喜马拉雅",
    "category": "音乐",
    "summary": "600 万 + 成人有声节目、11 万 + 儿童音频，涵盖儿童故事、有声小说、相声评书、播客、新闻资讯等丰富品类，适配智能音箱、故事机、智能闹钟、智能手表、AI陪伴玩具，适合全年龄段",
    "description": "600 万 + 成人有声节目、11 万 + 儿童音频，涵盖儿童故事、有声小说、广播剧、相声评书、人文历史、知识课程、播客、新闻资讯等丰富品类，适配智能音箱、故事机、智能闹钟、智能手表、口袋学习机、AI陪伴玩具，适合全年龄段\n有声书、曲艺、早教全覆盖，一站式音频内容平台",
    "logoText": "FM",
    "logoTone": "orange",
    "image": "ximalaya.webp",
    "scenarios": [
      "适配智能音箱、故事机、智能闹钟、智能手表、口袋学习机、AI陪伴玩具，适合全年龄段"
    ],
    "sortOrder": 11
  },
  {
    "slug": "yunting",
    "title": "云听・国家队精品音频平台",
    "category": "音乐",
    "summary": "中央广播电视总台旗下精品正版音频资源，汇集广播直播、新闻资讯、有声读物、国学文化、少儿诵读等内容，适配智能音箱、智能闹钟、智能手表、AI陪伴玩具，适合全年龄段",
    "description": "中央广播电视总台旗下精品正版音频资源，汇集总台广播直播、新闻资讯、人文历史、广播剧、有声读物、国学文化、少儿诵读、科普教育等内容，具备权威主流内容属性，适配智能音箱、智能闹钟、智能手表、口袋学习机、AI陪伴玩具，适合全年龄段\n权威正版内容，兼顾知识学习与休闲文娱",
    "logoText": "NEW",
    "logoTone": "blue",
    "image": "yunting.webp",
    "scenarios": [
      "适配智能音箱、智能闹钟、智能手表、口袋学习机、AI陪伴玩具，适合全年龄段"
    ],
    "sortOrder": 12
  },
  {
    "slug": "koudai",
    "title": "口袋故事・青少儿有声阅读平台",
    "category": "音乐",
    "summary": "百万集优质青少儿有声阅读，汇集睡前故事、国学诵读、中外童话、科普百科、少儿英语、课本音频等内容，适配儿童手表、口袋学习机、故事机、智能音箱，适合0‑12岁（幼儿至小学阶段）",
    "description": "百万集优质青少儿正版有声阅读资源库，汇集睡前故事、国学诵读、中外童话、校园IP故事、科普百科、少儿英语、课本音频等内容，支持分龄内容筛选，满足孩子启蒙陪伴、课外阅读听读需求。适配儿童手表、口袋学习机、听力宝、故事机、智能音箱、学习平板、AI陪伴玩具，适合0‑12岁（幼儿至小学阶段）\n聆听优质故事，培养少儿阅读素养与认知能力",
    "logoText": "NEW",
    "logoTone": "blue",
    "image": "koudai.webp",
    "scenarios": [
      "适配儿童手表、口袋学习机、听力宝、故事机、智能音箱、学习平板、AI陪伴玩具，适合0‑12岁（幼儿至小学阶段）"
    ],
    "sortOrder": 13
  },
  {
    "slug": "yingshi",
    "title": "影视视频资源库",
    "category": "音乐",
    "summary": "汇聚爱奇艺、咪咕、影牛牛、爆米花短剧，涵盖电影、电视剧、短剧、动画、纪录片、综艺等多品类视频内容。适配学习平板、带屏智能音箱、带屏智能闹钟、家用带屏IoT设备，适合全年龄段",
    "description": "汇聚爱奇艺、咪咕、影牛牛、爆米花短剧，涵盖电影、电视剧、短剧、动画、纪录片、综艺等多品类视频内容，满足家庭娱乐观影需求。适配学习平板、带屏智能音箱、带屏智能闹钟、家用带屏IoT设备、AI陪伴玩具，适合全年龄段\n长剧短剧丰富选择，居家休闲视听娱乐",
    "logoText": "影视视频",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "适配学习平板、带屏智能音箱、带屏智能闹钟、家用带屏IoT设备、AI陪伴玩具，适合全年龄段"
    ],
    "sortOrder": 14
  },
  {
    "slug": "kge",
    "title": "K歌方案（雷石、全民、酷狗、唱吧）",
    "category": "音乐",
    "summary": "集合雷石、全民K歌、酷狗K歌、唱吧多家头部K歌正版曲库资源，支持伴奏、原唱切换、同步歌词，适配带屏智能音箱、等家用带屏IoT设备，适合全年龄段，满足家庭聚会、居家休闲演唱需求",
    "description": "集合雷石、全民K歌、酷狗K歌、唱吧多家头部K歌正版曲库资源，支持伴奏、原唱切换、同步歌词，可提供多套曲库选型，适配家庭硬件K歌娱乐场景，适配带屏智能音箱、带屏智能闹钟、家用带屏IoT设备、学习平板、AI陪伴玩具，适合全年龄段，满足家庭聚会、居家休闲演唱需求\n家庭互动欢唱，打造沉浸式影音娱乐体验",
    "logoText": "K歌方案",
    "logoTone": "red",
    "image": null,
    "scenarios": [
      "适配家庭硬件K歌娱乐场景，适配带屏智能音箱、带屏智能闹钟、家用带屏IoT设备、学习平板、AI陪伴玩具，适合全年龄段，满足家庭聚会、居家休闲演唱需求"
    ],
    "sortOrder": 15
  },
  {
    "slug": "haobaba",
    "title": "好爸爸・K12 课内同步教育内容库・音频",
    "category": "教育",
    "summary": "人教社、外研社等15 大出版社 28 套版本共 253 册课本，配套 9 学科 112 套名师音频课，适配听力宝、学习手表、学习机、小屏 / 无屏学习硬件，适合6‑18 岁（小学、初中、高中 K12 阶段）",
    "description": "人教社、外研社等15 大出版社 28 套版本共 253 册课本，配套 9 学科 112 套名师音频课，内置学练测体系与词典工具等，适配听力宝、学习手表、学习机、小屏 / 无屏学习硬件，适合6‑18 岁（小学、初中、高中 K12 阶段）\n课本同步听学，碎片时间夯实课内基础",
    "logoText": "课内同步教育",
    "logoTone": "orange",
    "image": null,
    "scenarios": [
      "适配听力宝、学习手表、学习机、小屏 / 无屏学习硬件，适合6‑18 岁（小学、初中、高中 K12 阶段）"
    ],
    "sortOrder": 16
  },
  {
    "slug": "haobaba-shuxue",
    "title": "好爸爸・数学内容・音视频",
    "category": "教育",
    "summary": "好爸爸数学内容包含视频课、音频、绘本，聚焦数学思维与脑力素养培养；可在熏听机、AI闹钟、平板、机顶盒等硬件使用，支持集中学习与碎片化熏听；适合3‑12岁儿童，3‑7岁做幼升小启蒙，7‑12岁进行逻辑脑力拓展。",
    "description": "产品简介：\n好爸爸数学内容集合视频课、有声音频、趣味绘本多种资源形态，覆盖学龄前到小学阶段，包含幼升小数学衔接、数理逻辑、空间思维、棋类、编程启蒙、全脑记忆力开发以及STEM科普、专注力培养相关内容，兼顾系统教学与碎片化熏听，着重锻炼孩子数学思维与脑力素养。\n应用设备场景：\n视频课程需要带屏硬件，适配学习平板、教育机顶盒；音频、绘本资源可在无屏AI闹钟、熏听机、听力宝、AI音箱、早教机上播放。支持家庭集中专项学习，也可用于通勤、睡前碎片化熏陶。\n适用年龄段：\n3‑12岁，3‑7岁侧重幼升小数学启蒙，7‑12岁用于逻辑思维、脑力拓展提升。",
    "logoText": "数学内容",
    "logoTone": "ink",
    "image": null,
    "scenarios": [
      "AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板、教育机顶盒； 支持家庭集中专项学习，也可用于通勤、睡前碎片化熏陶。"
    ],
    "sortOrder": 17
  },
  {
    "slug": "haobaba-kewaiyuedu",
    "title": "好爸爸・课外阅读・音频",
    "category": "教育",
    "summary": "共计 16 大主题、2000+小节资源，分为古诗词、国学经典、口语算术、英语启蒙、幼儿早教、知识百科等；适配 AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板、教育机顶盒；适用3‑12 岁儿童",
    "description": "好爸爸课外阅读为一套 API 接入的纯音频课外内容库，共计 16 大主题、2000+小节资源，分为古诗词、国学经典、口语算术、听力训练、英语伴读、少儿素养、热门故事、广播剧、国学经典、亲子教育、世界名著、质课堂、童话故事、英语启蒙、幼儿早教、知识百科。内容包含古诗赏析、成语国学（配备粤语版本）、数字启蒙、大量英文儿歌伴读、安全品格习惯及百科科普故事等，兼顾普通话、粤语、英文内容，侧重孩子熏听熏陶，实现语文国学积累、英语磨耳朵、品格素养培养。\n全部为音频资源，无屏与带屏 AI 硬件均可通过 API 调取使用，适配 AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板、教育机顶盒；适合睡前、上下学通勤居家碎片化熏听，用于国学语文积累、英语听力启蒙、习惯品格引导、低龄数字趣味学习。\n3‑12 岁，低幼儿童适合儿歌、习惯故事；学龄前至小学阶段适配古诗词、国学、英文听力、百科素养类音频。",
    "logoText": "课外阅读",
    "logoTone": "yellow",
    "image": null,
    "scenarios": [
      "AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板、教育机顶盒；适合睡前、上下学通勤居家碎片化熏听，用于国学语文积累、英语听力启蒙、低龄数字趣味学习。"
    ],
    "sortOrder": 18
  },
  {
    "slug": "haobaba-huibengushi",
    "title": "好爸爸・绘本故事・音频",
    "category": "教育",
    "summary": "汇集大量中外绘本改编音频，涵盖传统神话节日、中外经典童话名著、情商品格故事、国学诗文、科普故事等多元题材，适配 AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板，使用3‑12 岁儿童。",
    "description": "好爸爸绘本故事是一套 API 接入的纯音频有声读物资源库，汇集大量中外绘本改编音频，涵盖传统神话节日、中外经典童话名著、情商品格故事、国学诗文、科普故事等多元题材，通过听故事的形式，拓展孩子文学视野，培养情商品格，丰富课外知识积累。\n全部为音频资源，无屏、带屏 AI 硬件均可通过 API 调用，适配 AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板、教育机顶盒；多用于睡前听读、居家、出行通勤等碎片化熏听场景，满足亲子伴听、文学熏陶、品格引导的需求。\n适用3‑12 岁，低幼孩子适合趣味短篇绘本小故事，学龄孩子可收听神话传说、中外名著、国学科普类内容。",
    "logoText": "绘本故事",
    "logoTone": "pink",
    "image": null,
    "scenarios": [
      "AI 闹钟、熏听机、听力宝、AI 音箱、早教机、学习平板、教育机顶盒；多用于睡前听读、居家、出行通勤等碎片化熏听场景，满足亲子伴听、文学熏陶、品格引导的需求。"
    ],
    "sortOrder": 19
  },
  {
    "slug": "youxuepai",
    "title": "优学派・小初同步课程・音视频",
    "category": "教育",
    "summary": "5 万+同步教学视频，小初全科覆盖，适配人教版、北师大版等数十种教材版本，预习复习全流程，学习机、平板、听力宝、AI 拍学机、手表均可使用，适合6-15 岁（小学、初中）",
    "description": "5 万+同步教学视频，小初全科覆盖，适配人教版、北师大版等数十种教材版本，预习复习全流程，学习机、平板、听力宝、AI 拍学机、手表均可使用，适合6-15 岁（小学、初中）\n同步校内课堂，居家自主高效提分",
    "logoText": "NEW",
    "logoTone": "blue",
    "image": "youxuepai.webp",
    "scenarios": [
      "学习机、平板、听力宝、AI 拍学机、手表均可使用，适合6-15 岁（小学、初中）"
    ],
    "sortOrder": 20
  },
  {
    "slug": "ergediandian-sp",
    "title": "儿歌点点・奇拉小队启蒙动画・视频",
    "category": "教育",
    "summary": "33 专辑 1600+ 集 幼儿早教视频，儿歌诗词 / 成语科普 / 趣味实验全覆盖，学习机、儿童手表、平板等带屏设备均可播放，适合学龄前 2‑6 岁幼儿",
    "description": "33 专辑 1600+ 集 幼儿早教视频，儿歌诗词 / 成语科普 / 趣味实验全覆盖，学习机、儿童手表、平板等带屏设备均可播放，适合学龄前 2‑6 岁幼儿\n趣味动画启蒙，寓教于乐助力 2-6 岁成长",
    "logoText": "NEW",
    "logoTone": "blue",
    "image": "ergediandian-sp.webp",
    "scenarios": [
      "学习机、儿童手表、平板等带屏设备均可播放，适合学龄前 2‑6 岁幼儿"
    ],
    "sortOrder": 21
  },
  {
    "slug": "ergediandian",
    "title": "儿歌点点・奇拉小队启蒙・音频",
    "category": "教育",
    "summary": "17 专辑 650+ 集 双语早教音库，儿歌 / 国学 / 科普谜语全覆盖，故事机、儿童手表、智能音箱全适配，适合学龄前 2‑6 岁幼儿",
    "description": "17 专辑 650+ 集 双语早教音库，儿歌 / 国学 / 科普谜语全覆盖，故事机、儿童手表、智能音箱全适配，适合学龄前 2‑6 岁幼儿\n无屏磨耳朵，轻松做幼儿双语启蒙",
    "logoText": "儿歌点点",
    "logoTone": "orange",
    "image": "ergediandian.webp",
    "scenarios": [
      "故事机、儿童手表、智能音箱全适配，适合学龄前 2‑6 岁幼儿"
    ],
    "sortOrder": 22
  },
  {
    "slug": "kewaixue",
    "title": "课外学・少儿素养启蒙・音频",
    "category": "教育",
    "summary": "144 门课程 3500+ 音频课件，诗词英语故事全覆盖，学习机、听力宝、AI 拍学机、故事机、智能音箱、儿童穿戴设备通用，适合3-12 岁（学龄前至小学阶段）",
    "description": "144 门课程 3500+ 音频课件，诗词英语故事全覆盖，学习机、听力宝、AI 拍学机、故事机、智能音箱、儿童穿戴设备通用，适合3-12 岁（学龄前至小学阶段）\n全科素养听学，拓展孩子综合眼界",
    "logoText": "课外学",
    "logoTone": "pink",
    "image": null,
    "scenarios": [
      "学习机、听力宝、AI 拍学机、故事机、智能音箱、儿童穿戴设备通用，适合3-12 岁（学龄前至小学阶段）"
    ],
    "sortOrder": 23
  },
  {
    "slug": "ziranpindu",
    "title": "自然拼读・音视频",
    "category": "教育",
    "summary": "整合课外学和优学派两套自然拼读资源，从字母发音到高阶拼读规则，实现见词能读、听音会写。适配口袋学习机、AI 拍学机、智能音箱、学习手表、平板，适合3‑12 岁（学龄前启蒙至小学全阶段）",
    "description": "整合两套自然拼读资源，课外学主打音频基础启蒙，优学派提供 1‑6 级完整视频进阶课程；从字母发音到高阶拼读规则，实现见词能读、听音会写，帮助孩子攻克英语开口、记单词难点。适配口袋学习机、听力宝、AI 拍学机、故事机、智能音箱、学习手表、平板、AI 玩具，适合3‑12 岁（学龄前启蒙至小学全阶段）\n标准发音跟读，夯实少儿英语拼读基础",
    "logoText": "自然拼读",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "适配口袋学习机、听力宝、AI 拍学机、故事机、智能音箱、学习手表、平板、AI 玩具，适合3‑12 岁（学龄前启蒙至小学全阶段）"
    ],
    "sortOrder": 24
  },
  {
    "slug": "wobei",
    "title": "沃贝・国际经典儿童动画・视频",
    "category": "教育",
    "summary": "汇集 80 部 / 季共 1500 + 集海外知名儿童动画，包含天线宝宝、花园宝宝、史努比等经典 IP，适配学习手表、口袋学习机、平板等各类带屏智能硬件，适合2‑10 岁（学龄前至小学阶段）",
    "description": "汇集 80 部 / 季共 1500 + 集海外知名儿童动画，包含天线宝宝、花园宝宝、史努比等经典 IP，多国原版动画资源，兼顾趣味启蒙与休闲娱乐，适配AI 玩具、带屏智能闹钟、学习手表、口袋学习机、平板等各类带屏智能硬件，适合2‑10 岁（学龄前至小学阶段）\n全球知名动画，低龄趣味启蒙护眼观看",
    "logoText": "沃贝",
    "logoTone": "ink",
    "image": null,
    "scenarios": [
      "适配AI 玩具、带屏智能闹钟、学习手表、口袋学习机、平板等各类带屏智能硬件，适合2‑10 岁（学龄前至小学阶段）"
    ],
    "sortOrder": 25
  },
  {
    "slug": "word-world",
    "title": "单词世界・艾美奖英语启蒙动画・视频",
    "category": "教育",
    "summary": "全季 84 集，角色物品均由英文单词字母构成，通过趣味冒险故事，沉浸式学习自然拼读与英文单词，适配学习手表、口袋学习机、平板、听力宝、AI 拍学机，适合3‑8 岁（学龄前至小学低年级）",
    "description": "美国 PBS 联合教育部出品、三届艾美奖获奖动画，全季 84 集，角色物品均由英文单词字母构成，通过趣味冒险故事，沉浸式学习自然拼读与英文单词，适配学习手表、口袋学习机、平板、听力宝、AI 拍学机、AI 玩具，适合3‑8 岁（学龄前至小学低年级）\n情境化拼读启蒙，轻松掌握英文词汇",
    "logoText": "W",
    "logoTone": "yellow",
    "image": "word-world.webp",
    "scenarios": [
      "适配学习手表、口袋学习机、平板、听力宝、AI 拍学机、AI 玩具，适合3‑8 岁（学龄前至小学低年级）"
    ],
    "sortOrder": 26
  },
  {
    "slug": "language-education",
    "title": "出海语言教育全套资源",
    "category": "教育",
    "summary": "包含 HSK 应试教程、试题、词汇工具书、iTEST 智能测评云平台，18 语种双向汉语小词典；搭配悠游少儿英语教程、336 册分级读物。适配学习手表、口袋学习机、听力宝、AI 拍学机，适合3‑14 岁（少儿全阶段，同时支持成人中文备考学习）",
    "description": "包含 HSK 应试教程、试题、词汇工具书、iTEST 智能测评云平台，18 语种双向汉语小词典；搭配悠游少儿英语教程、336 册分级读物，提供文本、音频、视频、XML、云端平台多格式素材。适配学习手表、口袋学习机、听力宝、AI 拍学机、AI 玩具，适合3‑14 岁（少儿全阶段，同时支持成人中文备考学习）\n覆盖海外应试与少儿双语启蒙，一站式语言学习素材",
    "logoText": "出海语言教育",
    "logoTone": "orange",
    "image": null,
    "scenarios": [
      "适配学习手表、口袋学习机、听力宝、AI 拍学机、AI 玩具，适合3‑14 岁（少儿全阶段，同时支持成人中文备考学习）"
    ],
    "sortOrder": 27
  },
  {
    "slug": "ant-dialogue-model",
    "title": "蚂蚁 AI 对话大模型",
    "category": "其他原子能力",
    "summary": "端云一体化AI智能模组，搭载智能语音与大模型交互引擎；支持语音、文字、图片多方式输入，语音唤醒，可自定义知识库、语音音色，国内外节点部署。适配智能手表、蓝牙耳机、AI陪伴玩具、智能闹钟、AI眼镜、口袋学习机、各类IoT智能终端",
    "description": "蚂蚁 AI 对话大模型产品基于智能语音、大模型、智能体等AI技术及端云一体化服务，提供语音指令、实时语音交互等能力，面向穿戴设备、耳机、玩具等行业/场景。\n产品核心能力如下：\n智能语音：提供语音识别及合成能力，默认支持中文、英文；\n交互引擎：支持基于知识库、智能体作为对话引擎，支持常见问题响应，支持配置语音指令，适配穿戴、玩具等场景；\n交互方式：支持语音、文字、图片作为交互输入内容；\n唤醒方式：支持语音唤醒，或调取API唤醒；\n接入方式：支持服务端API及端侧 SDK 两种接入方式；\n管理后台：支持针对知识库、智能体、语音音色、交互场景等进行后台管理与配置；",
    "logoText": "蚂蚁数科",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "智能手表、蓝牙耳机、AI陪伴玩具、智能闹钟、AI眼镜、口袋学习机、各类IoT智能终端"
    ],
    "sortOrder": 28
  },
  {
    "slug": "gemini",
    "title": "谷歌 Gemini 多模态 AI 大模型",
    "category": "其他原子能力",
    "summary": "谷歌多模态大模型，分为云端 API、端侧 Gemini‑Nano；支持文本、音频、图像理解，多语种能力强，适配海外 AI 陪伴玩具、智能音箱、穿戴、AI 眼镜等出海 IoT 硬件",
    "description": "产品简介：谷歌多模态大模型，分为云端 API、端侧 Gemini‑Nano；支持文本、音频、图像理解，多语种能力强，适配海外硬件。\n应用设备场景：海外 AI 陪伴玩具、智能音箱、穿戴、AI 眼镜等出海 IoT 硬件\n适用年龄段：全年龄段",
    "logoText": "Gemini",
    "logoTone": "ink",
    "image": null,
    "scenarios": [
      "海外 AI 陪伴玩具、智能音箱、穿戴、AI 眼镜等出海 IoT 硬件"
    ],
    "sortOrder": 29
  },
  {
    "slug": "twecall-ysp",
    "title": "腾讯云 TWeCall 微信音视频通话",
    "category": "其他原子能力",
    "summary": "实现硬件设备与微信双向音视频呼叫，秒级响应、原生微信通话体验；适配儿童学习手表、学生卡、AI陪伴玩具、养老健康手表、AI眼镜、居家中控屏、门禁设备。适用年龄段：全年龄段，重点面向儿童、老人亲情沟通场景",
    "description": "实现硬件设备与微信双向音视频呼叫，秒级响应、原生微信通话体验；适配多类系统、资源占用低，无需自建服务器，快速接入亲情通话功能。适配儿童学习手表、学生卡、AI陪伴玩具、养老健康手表、AI眼镜、居家中控屏、门禁设备。适用年龄段：全年龄段，重点面向儿童、老人亲情沟通场景",
    "logoText": "TWeCall",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "儿童学习手表、学生卡、AI陪伴玩具、养老健康手表、AI眼镜、居家中控屏、门禁设备"
    ],
    "sortOrder": 30
  },
  {
    "slug": "twecall-yp",
    "title": "腾讯云纯音频 TWeCall",
    "category": "其他原子能力",
    "summary": "硬件与微信双向音频通话方案，一键呼叫微信语音、秒级响应、微信原生通话体验；适配儿童学习手表、学生卡、AI陪伴玩具、养老健康手表、AI眼镜、智能闹钟、智能音箱、家居中控屏、门禁设备。适用年龄段：全年龄段，重点面向儿童、老人亲情及应急沟通场景",
    "description": "硬件与微信双向音频通话方案，一键呼叫微信语音、秒级响应、微信原生通话体验；适配轻量化低功耗系统，资源占用低，提供SDK快速接入，无需自建服务器。适配儿童学习手表、学生卡、AI陪伴玩具、养老健康手表、AI眼镜、智能闹钟、智能音箱、家居中控屏、门禁设备。适用年龄段：全年龄段，重点面向儿童、老人亲情及应急沟通场景",
    "logoText": "TWeCall",
    "logoTone": "orange",
    "image": null,
    "scenarios": [
      "儿童学习手表、学生卡、AI陪伴玩具、养老健康手表、AI眼镜、智能闹钟、智能音箱、家居中控屏、门禁设备"
    ],
    "sortOrder": 31
  },
  {
    "slug": "aimore",
    "title": "AI 多模态综合资源",
    "category": "其他原子能力",
    "summary": "集成AI多模态对话、同声翻译、会议纪要、音视频通话翻译等多项AI能力，赋能设备智能交互与跨语言沟通。适配智能手表、口袋学习机、听力宝、AI眼镜、AI陪伴玩具、居家中控屏。适用年龄段：全年龄段",
    "description": "集成AI多模态对话、同声翻译、会议纪要、音视频通话翻译等多项AI能力，支持语音、文字、图像交互，可通过SDK/API接入硬件，赋能设备智能交互与跨语言沟通。适配智能手表、口袋学习机、听力宝、AI眼镜、AI陪伴玩具、居家中控屏。适用年龄段：全年龄段",
    "logoText": "AI 多模态综合资源",
    "logoTone": "red",
    "image": null,
    "scenarios": [
      "智能手表、口袋学习机、听力宝、AI眼镜、AI陪伴玩具、居家中控屏"
    ],
    "sortOrder": 32
  },
  {
    "slug": "offline-speech",
    "title": "离线语音算法",
    "category": "其他原子能力",
    "summary": "中英文离线语音识别方案，支持自定义多条命令词；无需云端联网即可执行语音指令，占用内存最低仅25KB，轻量化SDK适配低功耗硬件。适配智能手表、学生卡、AI陪伴玩具、智能闹钟、各类无屏/小屏IoT终端。适用年龄段：全年龄段",
    "description": "中英文离线语音识别方案，支持自定义多条命令词；无需云端联网即可执行语音指令，占用内存最低仅25KB，轻量化SDK适配低功耗硬件。适配智能手表、学生卡、AI陪伴玩具、智能闹钟、各类无屏/小屏IoT终端。适用年龄段：全年龄段",
    "logoText": "离线语音算法",
    "logoTone": "yellow",
    "image": null,
    "scenarios": [
      "智能手表、学生卡、AI陪伴玩具、智能闹钟、各类无屏/小屏IoT终端"
    ],
    "sortOrder": 33
  },
  {
    "slug": "speech-noise-reduction",
    "title": "语音降噪算法",
    "category": "其他原子能力",
    "summary": "音频降噪处理技术，可有效消除风噪、环境嘈杂杂音，优化拾音收音效果，提升语音通话、语音识别清晰度，轻量化SDK可快速接入硬件。适配智能手表、AI眼镜、智能音箱、学习机、耳机、各类带麦克风IoT设备。适用年龄段：全年龄段",
    "description": "音频降噪处理技术，可有效消除风噪、环境嘈杂杂音，优化拾音收音效果，提升语音通话、语音识别清晰度，轻量化SDK可快速接入硬件。适配智能手表、AI眼镜、智能音箱、学习机、耳机、各类带麦克风IoT设备。适用年龄段：全年龄段",
    "logoText": "语音降噪算法",
    "logoTone": "ink",
    "image": null,
    "scenarios": [
      "智能手表、AI眼镜、智能音箱、学习机、耳机、各类带麦克风IoT设备"
    ],
    "sortOrder": 34
  },
  {
    "slug": "zhifu",
    "title": "穿戴设备离线支付能力",
    "category": "其他原子能力",
    "summary": "硬件端支持微信、支付宝离线展码支付，无需网络，屏幕生成付款二维码/条形码即可线下扫码消费，提供成熟对接方案。适配智能手表、学生卡、电子吧唧等带屏穿戴终端。适用年龄段：全年龄段",
    "description": "硬件端支持微信、支付宝离线展码支付，无需网络，屏幕生成付款二维码/条形码即可线下扫码消费，提供成熟对接方案。适配智能手表、学生卡、电子吧唧等带屏穿戴终端。适用年龄段：全年龄段",
    "logoText": "离线支付能力",
    "logoTone": "pink",
    "image": null,
    "scenarios": [
      "智能手表、学生卡、电子吧唧等带屏穿戴终端"
    ],
    "sortOrder": 35
  },
  {
    "slug": "chengchema",
    "title": "支付宝乘车码穿戴方案",
    "category": "其他原子能力",
    "summary": "穿戴设备接入支付宝乘车码能力，可离线亮码，覆盖全国千余城公交、地铁，无需携带手机即可完成公共交通出行扣费，提供成熟硬件对接方案。适配智能手表、学生卡、电子吧唧等带屏穿戴终端。适用年龄段：全年龄段，尤其适合学生通勤出行使用",
    "description": "穿戴设备接入支付宝乘车码能力，可离线亮码，覆盖全国千余城公交、地铁，无需携带手机即可完成公共交通出行扣费，提供成熟硬件对接方案。适配智能手表、学生卡、电子吧唧等带屏穿戴终端。适用年龄段：全年龄段，尤其适合学生通勤出行使用",
    "logoText": "支付宝乘车码",
    "logoTone": "yellow",
    "image": null,
    "scenarios": [
      "智能手表、学生卡、电子吧唧等带屏穿戴终端，尤其适合学生通勤出行使用"
    ],
    "sortOrder": 36
  },
  {
    "slug": "mayisenlin",
    "title": "蚂蚁森林穿戴端公益模块",
    "category": "其他原子能力",
    "summary": "支付宝蚂蚁森林穿戴端应用，可一键收发绿色能量，依托低碳行为积攒能量，线上种树参与环保公益，提升设备用户活跃度。适配智能手表、学生卡、电子吧唧等带屏穿戴终端。适用年龄段：全年龄段，学生群体活跃度较高",
    "description": "支付宝蚂蚁森林穿戴端应用，可一键收发绿色能量，与手机支付宝账号数据互通；依托低碳行为积攒能量，线上种树参与环保公益，提升设备用户活跃度，提供成熟硬件对接方案。适配智能手表、学生卡、电子吧唧等带屏穿戴终端。适用年龄段：全年龄段，学生群体活跃度较高",
    "logoText": "蚂蚁森林",
    "logoTone": "orange",
    "image": null,
    "scenarios": [
      "智能手表、学生卡、电子吧唧等带屏穿戴终端，学生群体活跃度较高"
    ],
    "sortOrder": 37
  },
  {
    "slug": "mayijiankang",
    "title": "蚂蚁健康 AI 大模型",
    "category": "其他原子能力",
    "summary": "蚂蚁自研多模态健康大模型，可对接健康硬件自动同步血氧、血压、睡眠等体征数据并生成AI解读；支持体检报告解析、肌肤问题检测、健康问答。适配智能手表、血压仪、AI美妆镜、家用健康监测IoT设备。适用年龄段：全年龄段",
    "description": "蚂蚁自研多模态健康大模型，可对接健康硬件自动同步血氧、血压、睡眠等体征数据并生成AI解读；支持体检报告解析、肌肤问题检测、健康问答，搭建个人及全家健康档案，输出调理与护肤建议。适配智能手表、血压仪、AI美妆镜、家用健康监测IoT设备。适用年龄段：全年龄段",
    "logoText": "蚂蚁健康",
    "logoTone": "blue",
    "image": null,
    "scenarios": [
      "智能手表、血压仪、AI美妆镜、家用健康监测IoT设备"
    ],
    "sortOrder": 38
  },
  {
    "slug": "mayiafu",
    "title": "蚂蚁阿福 IoT 健康智能体",
    "category": "其他原子能力",
    "summary": "IoT健康落地服务载体，硬件厂商可定制专属品牌AI健康管家页面；可搭建健康报告、私域营销、自营商城运营阵地，为品牌高端用户提供长效健康管理增值服务。适配智能手表、血压仪、家用健康监测硬件、穿戴类IoT终端。适用年龄段：全年龄段，适合有健康管理需求人群、银行高端客户运营",
    "description": "IoT健康落地服务载体，硬件厂商可定制专属品牌AI健康管家页面；复用专业医疗算法、健康数据库，实现设备扫码绑定、多端健康数据同步，可搭建健康报告、私域营销、自营商城运营阵地，为品牌高端用户提供长效健康管理增值服务。适配智能手表、血压仪、家用健康监测硬件、穿戴类IoT终端。适用年龄段：全年龄段，适合有健康管理需求人群、银行高端客户运营",
    "logoText": "蚂蚁阿福",
    "logoTone": "yellow",
    "image": null,
    "scenarios": [
      "智能手表、血压仪、家用健康监测硬件、穿戴类IoT终端。适合有健康管理需求人群、银行高端客户运营"
    ],
    "sortOrder": 39
  },
  {
    "slug": "meiyan",
    "title": "全维度美颜算法",
    "category": "其他原子能力",
    "summary": "轻量化图像美颜处理算法，支持人脸美肤、磨皮、美白、瘦脸、五官微调等多维度美颜效果，实时优化自拍视频画面。适配AI美妆镜、智能手表、带屏音箱、学习平板、居家中控屏、AI陪伴玩具。适用年龄段：全年龄段",
    "description": "轻量化图像美颜处理算法，支持人脸美肤、磨皮、美白、瘦脸、五官微调等多维度美颜效果，SDK可快速接入带屏摄像硬件，实时优化自拍视频画面。适配AI美妆镜、智能手表、带屏音箱、学习平板、居家中控屏、AI陪伴玩具。适用年龄段：全年龄段",
    "logoText": "美颜算法",
    "logoTone": "pink",
    "image": null,
    "scenarios": [
      "AI美妆镜、智能手表、带屏音箱、学习平板、居家中控屏、AI陪伴玩具"
    ],
    "sortOrder": 40
  },
  {
    "slug": "xinliceping",
    "title": "儿童心理健康测评模块",
    "category": "其他原子能力",
    "summary": "趣味问卷测评，报告同步家长小程序，完成测评‑智能分析‑情绪陪伴‑家长知情的闭环守护。适配口袋学习机、学习平板、AI陪伴玩具、学生手表、听力宝。适用年龄段：6‑14岁（小学至初中阶段）",
    "description": "携手青松测评打造少儿心理健康服务，搭载山东师范大学研发专业测评量表，接入科大讯飞心理情绪大模型；趣味问卷测评，报告同步家长小程序，完成测评‑智能分析‑情绪陪伴‑家长知情的闭环守护。适配口袋学习机、学习平板、AI陪伴玩具、学生手表、听力宝。适用年龄段：6‑14岁（小学至初中阶段）",
    "logoText": "心理健康测评",
    "logoTone": "red",
    "image": null,
    "scenarios": [
      "口袋学习机、学习平板、AI陪伴玩具、学生手表、听力宝"
    ],
    "sortOrder": 41
  }
];

export function findResource(slug) {
  return resources.find(resource => resource.slug === slug);
}
